module.exports = __webpack_public_path__ + "static/features-slide2-63b50920674f36e12d798febfa3cc38f.png";